import {Component, OnInit} from '@angular/core';
import {AuthService} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-logout',
    template: ``,
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(
        protected auth: AuthService,
    ) {
    }

    ngOnInit() {
        this.auth.logout();
    }

}
